import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import actions from './action'
import getters from './getters'

Vue.use(Vuex)

const state = {
  phoneType: '',
  platform: '',
  h5phoneType: 0,
  channelId: 0,
  userPhone: '',
  parkToken: '',
  position: {},//之前页面位置
  channelApiUrl: '',//园区域名
  chooseMembersId: '',//要选择的人员ID
  deleteMembersId: '',//要删除的人员ID
  selectedMembersId: [],//已经选择的人员ID
  pdfUrl: '',//党章PDF
  examinationResult: '',//考试成绩
  isAnswerDisplay: 2,//考试答案显示
  courseWareUrl: '',//课程PDF地址
  courseStartTime: '',//课程开始计时
  courseDetail: {},//课程详情
  myInfo: {},//我的信息
  chooseBranch: {id: '', name: ''},//已经选择的党支部
  companyId: '',//公司ID
  companyName: '',//公司名字
  isRecordDraft: false,//是否为编辑草稿
}

export default new Vuex.Store({
	state,
	getters,
	actions,
	mutations,
})



// WEBPACK FOOTER //
// ./src/story/index.js